jQuery(document).ready(function ($) {
  $("#mobile-menu .menu-item-has-children").each(function () {
    var $menuItem = $(this);
    var $subMenuToggle = $(
      '<svg class="icon svg#chevron-down transition-all duration-500"><use href="#icon-Arrow-12"/></svg>'
    );
    $menuItem.prepend($subMenuToggle);

    $subMenuToggle.on("click", function () {
      var $subMenu = $menuItem.children("ul");
      if ($subMenu.is(":visible")) {
        $subMenu.slideUp();
        $($subMenuToggle).removeClass("rotate-180");
        $($subMenuToggle).addClass("rotate-0");
      } else {
        $subMenu.slideDown();
        $($subMenuToggle).removeClass("rotate-0");
        $($subMenuToggle).addClass("rotate-180");
      }
    });
  });
});
